import { motion } from 'framer-motion'
import * as SiIcons from 'react-icons/si'
import Card from '../ui/Card'
import Badge from '../ui/Badge'
import { urlFor } from '../../lib/sanity'

const platformNameMap = {
    linkedin: 'SiLinkedin',
    twitter: 'SiTwitter',
    x: 'SiX',
    github: 'SiGithub',
    gitlab: 'SiGitlab',
    instagram: 'SiInstagram',
    facebook: 'SiFacebook',
    youtube: 'SiYoutube',
    dribbble: 'SiDribbble',
    behance: 'SiBehance',
    figma: 'SiFigma',
    discord: 'SiDiscord',
    slack: 'SiSlack',
    telegram: 'SiTelegram',
    whatsapp: 'SiWhatsapp',
    email: 'SiGmail',
    website: 'SiCodepen',
    portfolio: 'SiCodepen',
    codepen: 'SiCodepen',
    jsfiddle: 'SiJsfiddle',
    medium: 'SiMedium',
    dev: 'SiDev',
    hashnode: 'SiHashnode',
    stackoverflow: 'SiStackoverflow',
}

const getPlatformIcon = (platformName) => {
    const iconName = platformName ? platformName.toLowerCase() : ''
    const compName = platformNameMap[iconName] || 'SiCodepen'
    return SiIcons[compName] || SiIcons.SiCodepen
}

export default function LinkCard({ item }) {
    const IconComponent = getPlatformIcon(item.name)
    const [primaryTag, ...restTags] = Array.isArray(item.tags) ? item.tags : []

    return (
        <Card
            as={motion.a}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent p-4 shadow-brutal-sm hover:shadow-brutal transition-shadow duration-200"
            whileHover={{ scale: 1.02, y: -2 }}
            whileTap={{ scale: 0.98 }}
            aria-label={`${item?.name || 'Link'}${item?.description ? ` – ${item.description}` : ''}`}
        >
            <div className="flex items-start gap-4">
                <motion.div className="w-12 h-12 bg-zinc-100 dark:bg-zinc-900 flex items-center justify-center flex-shrink-0" whileHover={{ rotate: 5 }}>
                    {item.logo ? (
                        <img src={urlFor(item.logo).width(48).height(48).url()} alt="" className="w-6 h-6 object-contain" />
                    ) : (
                        <IconComponent className="w-6 h-6 text-zinc-700 dark:text-zinc-300" />
                    )}
                </motion.div>
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-base font-semibold text-black dark:text-white truncate group-hover:text-accent transition-colors">
                            {item.name}
                        </h3>
                        {primaryTag && <Badge tone="accent">{primaryTag}</Badge>}
                    </div>
                    {item.description && <p className="mt-0.5 text-sm text-zinc-600 dark:text-zinc-400 line-clamp-2">{item.description}</p>}
                    {restTags.length > 0 && (
                        <div className="mt-2 flex flex-wrap gap-1.5">
                            {restTags.map((t, i) => (
                                <span key={i} className="px-2 py-0.5 text-[11px] border border-accent text-accent font-mono font-medium">
                                    {t}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </Card>
    )
}
